export { default } from './EmployeeProfile.jsx';
